import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

let scene, camera, renderer;
let ambientLight, pointLight, directionalLight;
let width = window.innerWidth;
let height = window.innerHeight;
let sectionsContainer, scrollX, scrollWidth;

let scrollRatio = 0;

let currentSection = 0;
let sectionRatio = 0;

let allObjects = [];
let linkClickState = {};




//setup
function setup() {
    const canvas = document.querySelector('canvas.webgl');
    scene = new THREE.Scene();

    initCamera();
    initLight();
    loadObjects();
    updateBackgroundColor();
    

    renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: false });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setClearColor(0xffffff, 0.3); 
    renderer.toneMappingExposure = 1.2; 

    window.addEventListener('resize', onWindowResize);
    sectionsContainer = document.querySelector('.sections-container');
    sectionsContainer.addEventListener('scroll', scroll);

    
    // h1,h3 größen 
    updateH1Sizes();
    
}

//--------------------------------------------------------------------------------------------------------------------------------//
/////////3D////////////////////
//--------------------------------------------------------------------------------------------------------------------------------//
function animate() {
    
    //rufe mich beim nächten bild wieder auf 
    requestAnimationFrame(animate);

   
    if (allObjects.length === 0) {
        renderer.render(scene, camera);
        return;
    }

    let currentObject = allObjects.find(obj => obj.id === currentSection);
    
   
    if (!currentObject) {
        renderer.render(scene, camera);
        return;
    }

    // aktuelle objekt sichtbar machen, gehe dafür liste druch 
    
    for (let i = 0; i < allObjects.length; i++) {
        const obj = allObjects[i];
        
       
        if (obj.object3d) {
            // wenn die ID gleich der aktuellen section ist -> sichtbar
            // sonst- unsichtbar
            if (obj.id === currentSection) {
                obj.object3d.visible = true;
                obj.object3d.position.x = sectionRatio * 0.5;
                obj.object3d.position.y =   -6;
                obj.object3d.rotation.y= sectionRatio * 10;
                
                // einzel anpassung- größe, position 
                // x, y, z 
                if (obj.id === 7) {
                    obj.object3d.scale.set(0.01, 0.01, 0.01);
                    obj.object3d.position.set(0, -0.4, 0);  
                } else if (obj.id === 5) {
                    obj.object3d.scale.set(0.1, 0.1, 0.1);  
                    obj.object3d.position.set(0, -0.7, 0); 
                } else if (obj.id === 4) {
                    obj.object3d.scale.set(0.04, 0.04, 0.04);
                    obj.object3d.position.set(0, -0.5, 0);
                     } else if (obj.id === 6) {
                    obj.object3d.scale.set(0.01, 0.01,0.01);
                    obj.object3d.position.set(0, -0.4, 0);
                    } else if (obj.id === 2) {
                    obj.object3d.scale.set(0.5, 0.5, 0.5);
                    obj.object3d.position.set(0, -2, 0);
                    } else if (obj.id === 1) {
                    obj.object3d.scale.set(0.05, 0.05, 0.05);
                    obj.object3d.position.set(0, -0.5, 0);
                    } else if (obj.id === 9) {
                    obj.object3d.scale.set(0.2, 0.2, 0.2);
                    obj.object3d.position.set(0, -1, 0);
                    } else if (obj.id === 3) {
                    obj.object3d.scale.set(0.2, 0.2, 0.2);
                    obj.object3d.position.set(0, -1, 0);
                    } else if (obj.id === 10) {
                    obj.object3d.scale.set(0.3, 0.3, 0.3);
                    obj.object3d.position.set(0, -0.5, 0);
                    } else if (obj.id === 0) {
                    obj.object3d.scale.set(0.07, 0.07, 0.07);
                    obj.object3d.position.set(-0.1, -0.4, 0);
                    
                    
                   
                    
                }
            } else {
                obj.object3d.visible = false;
            }
        }
    }
    
   

    //renderer
    renderer.render(scene, camera);
}


//camera 
function initCamera(){
    
    camera = new THREE.PerspectiveCamera(75, width / height, 0.01, 100);
    camera.position.z = 1;
    scene.add(camera);
}


//licht 
function initLight(){
   
    ambientLight = new THREE.AmbientLight('rgb(255, 255, 255)', 2.5);
    scene.add(ambientLight);

   
    pointLight = new THREE.PointLight('rgb(255, 255, 255)', 1000);
    pointLight.position.set(5, 8, 8);
    scene.add(pointLight);

    
    directionalLight = new THREE.DirectionalLight('rgb(255, 255, 255)', 2.0);
    directionalLight.position.set(-8, 10, 8);
    scene.add(directionalLight);
}






//glb objekte reinladen 
function loadObjects(){
    const gltfLoader = new GLTFLoader();
    

    gltfLoader.load('./models/spike.glb', (gltf) => objectLoadedNew(gltf, 0, 'spike'));
    gltfLoader.load('./models/feather.glb', (gltf) => objectLoadedNew(gltf, 1, 'feather'));
    gltfLoader.load('./models/handel1.glb', (gltf) => objectLoadedNew(gltf, 2, 'handel'));
    gltfLoader.load('./models/roll.glb', (gltf) => objectLoadedNew(gltf, 3, 'roll'));
    gltfLoader.load('./models/pillow2.glb', (gltf) => objectLoadedNew(gltf, 4, 'pillow'));
    gltfLoader.load('./models/stuhl.glb', (gltf) => objectLoadedNew(gltf, 5, 'stuhl'));
    gltfLoader.load('./models/game.glb', (gltf) => objectLoadedNew(gltf, 6, 'game'));
    gltfLoader.load('./models/set2glb.glb', (gltf) => objectLoadedNew(gltf, 7, 'set'));
    gltfLoader.load('./models/lamp1.glb', (gltf) => objectLoadedNew(gltf, 8, 'lamp'));
    gltfLoader.load('./models/render.glb', (gltf) => objectLoadedNew(gltf, 9, 'render'));
    gltfLoader.load('./models/archiv.glb', (gltf) => objectLoadedNew(gltf, 10, 'render'));
} 


function objectLoadedNew(gltf, id, name) {
    console.log("ich bin da: id " + id + " mit Namen: " + name);

    const object3d = gltf.scene;
    const object = { 'name': name, 'id': id, 'object3d': object3d };
  
    allObjects.push(object);
    scene.add(object3d);
    object3d.position.z = -14;
    object3d.position.x = id;
    object3d.position.x = -30;

    console.log(allObjects);
    console.log("Anzahl der Objekte: " + allObjects.length);
    
}


// fenstergrößen anpassung 
function onWindowResize() {
    width = window.innerWidth;
    height = window.innerHeight;

    // kamera an neue größe anpassen
    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    // renderer an neue größe anpassen
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
}


// aufrufen
setup();
animate();



//-------------------------------------------------------------------------------------------------------------------------------//
// --------------------- scrollen----------------------------//
//-------------------------------------------------------------------------------------------------------------------------------//

//prüfe ob eine section in der mitte des bildschirms ist, Die Funktion schaut, ob der Schwerpunkt der Section ungefähr dort liegt, wo dein Blick automatisch hingeht.
function isSectionInCenter(index) {
    const section = document.querySelectorAll('.section')[index];
    if (!section) return false;
    
    //berechnet mittelpunkt des gesamten scrollraums 
    const sectionCenter = section.offsetLeft + section.offsetWidth / 2;

    //mittelpunkt des sichtbaren bereichs
    const viewportCenter = sectionsContainer.offsetWidth / 2;
    const sectionCenterInViewport = sectionCenter - sectionsContainer.scrollLeft;
    
    
    return Math.abs(sectionCenterInViewport - viewportCenter) < 100;
}

// scrolle eine section in die mitte, Mittelpunkt der Section = Mittelpunkt des Containers.
function scrollSectionIntoView(index) {
    const section = document.querySelectorAll('.section')[index];
    if (!section) return;
    
    // berechne wo die section sein sollte 
    const targetScroll = section.offsetLeft - (sectionsContainer.offsetWidth / 2) + (section.offsetWidth / 2);
    
    sectionsContainer.scrollTo({ left: targetScroll, behavior: 'smooth' });
}

// scroll-Event - wird aufgerufen wenn gescrollt wird
function scroll(event) {
    scrollX = sectionsContainer.scrollLeft;
    scrollWidth = sectionsContainer.scrollWidth - sectionsContainer.clientWidth;
    
    // berechne wie weit wird gescrollt haben 
    scrollRatio = scrollWidth > 0 ? scrollX / scrollWidth : 0;
    
    
    currentSection = Math.round(scrollRatio * 10);
    
    sectionRatio = (scrollRatio * 10) - currentSection;
    
    // aktualisiere 
    updateH1Sizes();
    updateBackgroundColor();
}

//  speichere scroll-position im browser
function saveScrollPosition() {
    localStorage.setItem('scrollPosition', sectionsContainer.scrollLeft);
}

// lade Scroll-Position aus browser
function loadScrollPosition() {
    const saved = localStorage.getItem('scrollPosition');
    if (saved) {
        sectionsContainer.style.scrollBehavior = 'auto';
        sectionsContainer.scrollLeft = parseInt(saved);
        setTimeout(() => { sectionsContainer.style.scrollBehavior = 'smooth'; }, 100);
    }
}

// starte alle event-listener wenn HTML geladen ist
document.addEventListener('DOMContentLoaded', () => {
    sectionsContainer = document.querySelector('.sections-container');
    
    // mausrad → horizontales scrollen
    document.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) > 50 || e.deltaMode === 1) {
            e.preventDefault();
            sectionsContainer.scrollLeft += e.deltaY || e.deltaX;
        }
    }, { passive: false, capture: true });
    
    // lade
    loadScrollPosition();
    
    // click: erst zentrieren, dann navigieren
    document.querySelectorAll('.section a[href*=".html"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            
            // welcher section gehört dieser link
            const sections = document.querySelectorAll('.section');
            let sectionIndex = 0;
            sections.forEach((s, i) => { if (s === link.closest('.section')) sectionIndex = i; });
            
            const linkKey = `link-${sectionIndex}`;
            
            // wenn section schon zentriert: navigiere sofort
            // sonst: zentriere erst, navigiere beim zweiten klick
            if (isSectionInCenter(sectionIndex) || linkClickState[linkKey]) {
                saveScrollPosition();
                window.location.href = link.href;
            } else {
                linkClickState[linkKey] = true;
                scrollSectionIntoView(sectionIndex);
                setTimeout(() => { linkClickState[linkKey] = false; }, 3000);
            }
        });
    });
});


sectionsContainer?.addEventListener('scroll', scroll);






//------------------------------------------------------------------------------//
/////Farben////
//---------------------------------------------------------------------------//


function updateBackgroundColor() {
    const container = document.querySelector('.sections-container');
    
   //rgb
    const colors = [
        [255, 105, 105],               // 1
        [127,255,212],             // 2
        [123,104,238],                   //3 
        [124,252,0],              // 4
        [189, 212, 121],              // 5
        [255, 158, 60],             // 6
        [245, 61, 98] ,             //7
        [168, 168, 168],             //8
        [255, 215, 0],            //9
        [216, 191, 216],            //10
        [176, 196, 222],            //11
         

    ];
    

    const numColors = colors.length - 1;
    const colorPosition = scrollRatio * numColors;
    const currentColorIndex = Math.floor(colorPosition);
    const nextColorIndex = Math.min(currentColorIndex + 1, colors.length - 1);
    const interpolation = colorPosition - currentColorIndex;
    
    
    const currentColor = colors[currentColorIndex];
    const nextColor = colors[nextColorIndex];
    
    const r = Math.round(currentColor[0] + (nextColor[0] - currentColor[0]) * interpolation);
    const g = Math.round(currentColor[1] + (nextColor[1] - currentColor[1]) * interpolation);
    const b = Math.round(currentColor[2] + (nextColor[2] - currentColor[2]) * interpolation);
    

    container.style.backgroundColor = `rgba(${r}, ${g}, ${b}, 0.7)`;
}






//--------------------------------------------------//
////////////überschriften////////////////
//-----------------------------------------------//

//je näher eine überschrift der bildschirmmitte ist, desto größer und sichtbarer 
function updateH1Sizes() {
    const h1Elements = document.querySelectorAll('h1');
    const h3Elements = document.querySelectorAll('h3');
    const centerX = sectionsContainer.clientWidth / 2;
    
    // gehe durch alle h1 elemente
    h1Elements.forEach(h1 => {
        
        const rect = h1.getBoundingClientRect();
        const h1CenterX = rect.left + rect.width / 2;
        
      
        const distanceFromCenter = Math.abs(h1CenterX - centerX);
        const maxDistance = centerX;
        const scale = Math.max(0.5, 1 - (distanceFromCenter / maxDistance) * 0.6);
        const opacity = Math.max(0.5, 1 - (distanceFromCenter / maxDistance) * 0.7);
        
    
        h1.style.fontSize = (2.0 * scale) + 'em';
        h1.style.opacity = opacity;
        h1.style.transition = 'all 0.1s ease-out';
    });
    
    // mache das gleiche für alle h3 elemente
    h3Elements.forEach(h3 => {
        const rect = h3.getBoundingClientRect();
        const h3CenterX = rect.left + rect.width / 2;
        
        const distanceFromCenter = Math.abs(h3CenterX - centerX);
        const maxDistance = centerX;
        
        const scale = Math.max(0.5, 1 - (distanceFromCenter / maxDistance) * 0.6);
        const opacity = Math.max(0.3, 1 - (distanceFromCenter / maxDistance) * 0.7);
        
        h3.style.fontSize = (1.5 * scale) + 'em';
        h3.style.opacity = opacity;
        h3.style.transition = 'all 0.1s ease-out';
    });
}